module.exports = __webpack_public_path__ + "static/img/co.a4978d05.png";